import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from '../api-config.service';
import { BaseApiService } from '../base-api.service';
import { Workflow, WorkflowUpdate } from '@wdx/shared/utils';

@Injectable({ providedIn: 'root' })
export class WorkflowApiService extends BaseApiService {
    update(entityId: string, updateData: WorkflowUpdate): Observable<Workflow> {
        return this.put<Workflow>(`workflow/${entityId}`, updateData);
    }
}
